import { render, staticRenderFns } from "./NearbyWells.vue?vue&type=template&id=23974a71"
import script from "./NearbyWells.vue?vue&type=script&lang=js"
export * from "./NearbyWells.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports